import { jsx } from "react/jsx-runtime";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { validateTidalLicense } from "../../base/index.js";
function ChevronRight(props) {
  return /* @__PURE__ */ jsx(
    ChevronRightIcon,
    {
      "data-testid": "ChevronRight",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ChevronRight",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
ChevronRight.tidalIconMeta = {
  categories: "arrows",
  name: "ChevronRight"
};
validateTidalLicense();
export {
  ChevronRight
};
//# sourceMappingURL=ChevronRight.js.map
